import { render, staticRenderFns } from "./PersonalizedSetting.vue?vue&type=template&id=331bd466&scoped=true&"
import script from "./PersonalizedSetting.vue?vue&type=script&lang=js&"
export * from "./PersonalizedSetting.vue?vue&type=script&lang=js&"
import style0 from "./PersonalizedSetting.vue?vue&type=style&index=0&id=331bd466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331bd466",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('331bd466')) {
      api.createRecord('331bd466', component.options)
    } else {
      api.reload('331bd466', component.options)
    }
    module.hot.accept("./PersonalizedSetting.vue?vue&type=template&id=331bd466&scoped=true&", function () {
      api.rerender('331bd466', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MarketingActivityEdit/PersonalizedSetting.vue"
export default component.exports